import { Component, Injector, OnInit, Input } from '@angular/core';
import { BaseFormComponent } from '../base-form.component';
import { ModalType } from '../../../../../js/interfaces/CoverpathTypes';
import { ModalService } from '../../../../services/modal/modal.service';

@Component({
  moduleId: module.id,
  selector: 'modal-trigger-button',
  templateUrl: './modal-trigger-button.component.html',
})
export class ModalTriggerButtonComponent extends BaseFormComponent implements OnInit {
  @Input() isDisabled: boolean;
  modalService: ModalService;

  constructor(protected injector: Injector) {
    super(injector);
    this.questionItem = this.injector.get('questionItem');
    this.modalService = this.injector.get(ModalService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  handleClick() {
    const modalConfig = {
      type: ModalType[this.questionItem.modalType],
      notShowClose: true,
      disableEscapeKeyPress: true,
    };

    this.modalService.activate(modalConfig);
  }
  resetValue() {}
  updateFromModel(): void {}
}
